<template>
    <ValidationObserver ref="form" class="box">
        <div class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl">Edit Sites/Clients</div>
            </div>
            <div class="form mt-3">
                <div class="row align-items-center">
                    <ValidationProvider class="col-md-12" v-slot="{errors}" rules="required" name="Name">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Site Name</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="client.name"
                            >
                            <FormError :error="errors[0]" name="Name"></FormError>
                        </div>
                    </ValidationProvider>

                    <div class="col-md-6" style="height: 113px;">
                        <label for="" class="form-label">Type Address</label>
                        <VueGoogleAutocomplete
                            id="map1"
                            classname="form-control"
                            placeholder="Start typing"
                            :country="`us`"
                            v-on:placechanged="getAddressData"
                        ></VueGoogleAutocomplete>
                    </div>

                    <ValidationProvider class="col-md-6" v-slot="{errors}" rules="required" name="Address">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Address</label>
                            <input type="text" v-model="client.address" class="form-control">
                            <FormError :error="errors[0]" name="Address"></FormError>
                        </div>
                    </ValidationProvider>

                    <ValidationProvider class="col-md-6" v-slot="{errors}" rules="required" name="City">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">City</label>
                            <input type="text" v-model="client.city" class="form-control">
                            <FormError :error="errors[0]" name="City"></FormError>
                        </div>
                    </ValidationProvider>

                    <ValidationProvider class="col-md-6" v-slot="{errors}" rules="required|numeric" name="Zip">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Zip Code</label>
                            <input type="text" v-model="client.zip_code" class="form-control">
                            <FormError :error="errors[0]" name="Zip"></FormError>
                        </div>
                    </ValidationProvider>

                    <ValidationProvider class="col-md-6" v-slot="{errors}" rules="required" name="State">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">State</label>
                            <input type="text" v-model="client.state" class="form-control">
                            <FormError :error="errors[0]" name="State"></FormError>
                        </div>
                    </ValidationProvider>

                    <ValidationProvider class="col-6" v-slot="{errors}" rules="required" name="Status">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Status</label>
                            <select id="" v-model="client.status" class="custom-select">
                                <option value="all" selected="">Select One</option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </select>
                            <FormError :error="errors[0]" name="Status"></FormError>
                        </div>
                    </ValidationProvider>

                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="btns-wrap">
                            <a href="javascript:void(0)" @click="location.reload()"
                               class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                            <a class="btn btn--secondary w-100 w-sm-auto" @click="validateFields">Save</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import SiteClientsService from "../services/SiteClientsService";
import CommonService from "../../../../AppUser/resources/js/services/CommonService";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
    name: "EditSite",
    components: {VueGoogleAutocomplete},
    props: {
        clientInfo: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            clientId: this.clientInfo.id,
            client: {
                address: null,
                city: null,
                name: null,
                status: null,
                state: null,
                zip_code: null,
            },
            states: [],
        }
    },
    methods: {
        async validateFields() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();
            if (!valid) {
                this.$showValidationErrorMessage()
            } else {
               await this.updateDataClient()
            }
        },
        getAddressData(place) {
            console.log(place)
            let { administrative_area_level_1, locality, postal_code, route, street_number } = place
            if (route && street_number) {
                this.client.address = `${street_number} ${route} `;
            } else {
                this.client.address = street_number || route || '';
            }
            this.client.zip = postal_code
            this.client.city = locality
            this.findStateFullName(administrative_area_level_1)
        },
        async getListOfStates() {
            try {
                const {data: states} = await CommonService.getListOfStates()
                this.states = states
            } catch (error) {
                this.$showErrorMessage();
            }
        },
        findStateFullName(stateN) {
            const foundState = this.states.find(state => state.abbreviation === stateN)
            this.client.state = foundState.name
        },
        setData() {
            for (const clientKey in this.clientInfo) {
                for (const formKey in this.client) {
                    if (clientKey === formKey) {
                        this.client[clientKey] = this.clientInfo[formKey];
                    }
                }
            }
        },
        async updateDataClient() {
            this.$showLoadingMessage()
            try {
                await SiteClientsService.updateClientInfo(this.clientId, this.client)
                this.$showSuccessMessage('Information has been updated');
                setTimeout(() => {
                    location.reload()
                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Information was not updated. Please try again');
            }
        }

    },
    mounted() {
        this.setData();
        this.getListOfStates();
    }
}

</script>

<style scoped>

</style>
